export default function format(text) {
	if (!text) return '';
	return text
		.replace(/(\r\n)|\r|\n/g, "<br /><br />")
		.replace(/{([\w\d\/]+)}/g, m => {
			const symbol = m[1].replace(/\//g, '').toLowerCase();
			return `<span class="mana small s${symbol}" title="${m}"></span>`;
		})
	;
}
